<template>
  <div @click="focusNewTag()" v-bind:class="{'read-only': readOnly}" class="bootstrap-tagsinput">
    <span v-for="(tag, index) in myTags" class="tag label label-info">
      {{ tag }}
      <span v-if="!readOnly" @click.prevent.stop="remove(index)" data-role="remove"></span>
    </span>
    <input v-if="!readOnly" autocomplete="off" v-bind:placeholder="getPlaceholder()" type="text" v-model="newTag" v-on:keydown.delete.stop="removeLastTag()" @keydown.down.prevent="down" @keydown.up.prevent="up" @keydown.enter.prevent="hit" @keydown.right="hit" @keydown.esc="blur" @blur="blur" @input="keydown" v-on:keydown.enter.prevent.stop="addNew(newTag)" class="new-tag"/>
    <!-- the list -->
    <ul class="list-group" v-show="hasItems">
      <li class="list-group-item" v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
        <span v-text="item.name"></span>
      </li>
    </ul>
  </div>
</template>
<script>
    import VueTypeahead from '../methods/vue-typeahead.js';
    export default {
        mixins: [VueTypeahead], // vue@1.0.21-
        name: 'InputTag',
        props: {
            tags: {
                type: Array,
                default: () => [],
            },
            placeholder: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: '',
            },
            onChange: {
                type: Function,
            },
            readOnly: {
                type: Boolean,
                default: false,
            },
            validate: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                myTags: this.tags,
                newTag: '',
                src: '/api/tags/get-list',
                limit: 5,
                minChars: 1,
                selectFirst: false, // Highlight the first item in the list (optional)
                // Override the default value (`q`) of query parameter name
                // Use a falsy value for RESTful query
                // (optional)
                queryParamName: 'search'
            };
        },
        created() {
            this.$eventHub.$on('updateTags' + this.name, this.refreshTags);
        },
        methods: {
            refreshTags(tags) {
                this.myTags = tags;
                this.$forceUpdate();
            },
            keydown() {
                this.query = this.newTag;
                this.update();
            },
            blur () {
                this.newTag = '';
                this.items = [];
                this.loading = false;
            },
            onHit (item) {
                this.addNew(item.name);
                this.blur();
            },
            focusNewTag() {
                if (this.readOnly) {
                    return;
                }
                this.$el.querySelector('.new-tag').focus();
            },
            addNew(tag) {
                if (tag && !this.myTags.includes(tag) && this.validateIfNeeded(tag)) {
                    this.myTags.push(tag);
                    this.tagChange();
                }
                this.newTag = '';
            },
            validateIfNeeded(tagValue) {
                if (this.validate === '' || this.validate === undefined) {
                    return true;
                } else if (Object.keys(validators).indexOf(this.validate) > -1) {
                    return validators[this.validate].test(tagValue);
                }
                return true;
            },
            remove(index) {
                this.myTags.splice(index, 1);
                this.tagChange();
            },
            removeLastTag() {
                if (this.newTag) {
                    return;
                }
                this.myTags.pop();
                this.tagChange();
            },
            getPlaceholder() {
                return this.placeholder;
            },
            tagChange() {
                if (this.onChange) {
                    // avoid passing the observer
                    this.onChange(JSON.parse(JSON.stringify(this.myTags)));
                }
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('updateTags' + this.name, this.refreshTags);
        }
    };
</script>